module.exports = __webpack_public_path__ + "static/media/Mobile_Data_Desenvolvimento_Web_Full_Stack.3ab29c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desWebFullStack/Mobile_Data_Desenvolvimento_Web_Full_Stack.png
// module id = 84
// module chunks = 0